import React from "react";
import PropTypes from "prop-types";

export default function PaymentCard(props) {
  return (
    <svg
      onClick={props.onClick}
      className={props.className}
      width={props.width}
      height={props.height}
      viewBox={`0 0 ${props.width} ${props.height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.2 0H0.8C0.358156 0 0 0.344381 0 0.769231V1.92308H15V0.769231C15 0.344381 14.6418 0 14.2 0Z"
        fill={props.fill}
      />
      <path
        d="M0 3.46154V9.23077C0 9.65562 0.358156 10 0.8 10H14.2C14.6418 10 15 9.65562 15 9.23077V3.46154H0ZM4.6 8.46154C4.15887 8.46154 3.8 8.11647 3.8 7.69231C3.8 8.11647 3.44112 8.46154 3 8.46154C2.55888 8.46154 2.2 8.11647 2.2 7.69231C2.2 7.26815 2.55888 6.92308 3 6.92308C3.44112 6.92308 3.8 7.26815 3.8 7.69231C3.8 7.26815 4.15887 6.92308 4.6 6.92308C5.04112 6.92308 5.4 7.26815 5.4 7.69231C5.4 8.11647 5.04112 8.46154 4.6 8.46154Z"
        fill={props.fill}
      />
    </svg>
  );
}
PaymentCard.propTypes = {
  className: PropTypes.string,
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  onClick: PropTypes.func
};
PaymentCard.defaultProps = {
  className: "",
  fill: "#063AC9",
  width: 15,
  height: 10,
  onClick: () => null
};
